import type { IconProps } from "types";

const ChannelNumerique = ({ color = "#B3B3B3", width = "20px", height= "20px" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.07721 13.3334C7.07721 12.8697 7.45305 12.4939 7.91667 12.4939H12.0833C12.547 12.4939 12.9228 12.8697 12.9228 13.3334V17.0834C12.9228 17.547 12.547 17.9228 12.0833 17.9228H7.91667C7.45305 17.9228 7.07721 17.547 7.07721 17.0834V13.3334ZM8.75613 14.1728V16.2439H11.2439V14.1728H8.75613Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92248 4.17294V12.494H17.0769V4.17294H2.92248ZM1.24356 4.16681C1.24356 3.24295 1.9925 2.49402 2.91635 2.49402H17.083C18.0069 2.49402 18.7558 3.24295 18.7558 4.16681V12.5001C18.7558 13.424 18.0069 14.1729 17.083 14.1729H2.91635C1.9925 14.1729 1.24356 13.424 1.24356 12.5001V4.16681Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32779 11.2505C8.32779 10.7869 8.70363 10.411 9.16725 10.411H10.8339C11.2975 10.411 11.6734 10.7869 11.6734 11.2505C11.6734 11.7141 11.2975 12.0899 10.8339 12.0899H9.16725C8.70363 12.0899 8.32779 11.7141 8.32779 11.2505Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99414 17.084C4.99414 16.6203 5.36998 16.2445 5.8336 16.2445H14.1669C14.6306 16.2445 15.0064 16.6203 15.0064 17.084C15.0064 17.5476 14.6306 17.9234 14.1669 17.9234H5.8336C5.36998 17.9234 4.99414 17.5476 4.99414 17.084Z"
        fill={color}
      />
    </svg>
  );
};
export default ChannelNumerique;
